import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ["Ce n'est pas une collection aléatoire de fiches trouvées sur internet.", "Ce n'est pas un livre théorique que tu dois réécrire avant de l'utiliser en classe.", "Ce n'est pas un contenu conçu pour un autre contexte que tu dois adapter entièrement."];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-231" data-mp="z0l517v29ysv">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-232" data-mp="u2jk0he2rper" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-233" data-mp="183dvxa0c08i6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-234" data-mp="13zy0gh000e72">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-235" data-mp="2jg6lqf9kamvl">
            <span className="text-2xl" aria-hidden="true" data-id="element-236" data-mp="2ff35vsrikqud">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-237" data-mp="2bvfmsysjufw1">
            Le système pédagogique d&apos;espagnol le plus complet pour professeurs francophones
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-238" data-mp="2kxos9a8ynj2k">Prof d&apos;Espagnol Prêt</h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-239" data-mp="2pu6tw18zv1ao">
            Système 8 en 1 · 5 Bonus Inclus · Tout prêt à utiliser dès aujourd&apos;hui
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-240" data-mp="1x7ugyx4ai2kf">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-241" data-mp="2265upixpgx7x">
            {negatives.map(item => <div key={item} className="flex items-start gap-3" data-id="element-242" data-mp="1egbgoy1nh2m3">
                <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-243" data-mp="1eeiafjuy8kem" />
                <p className="text-gray-400 text-sm" data-id="element-244" data-mp="2hq76rzwqh1me">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-245" data-mp="2crmgotb73ybo">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-246" data-mp="1yrux8d1wtpqa" />
            <div className="flex items-start gap-3 relative z-10" data-id="element-247" data-mp="1tttddpwntmdr">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-248" data-mp="1tvmll9mx8env" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-249" data-mp="27umbslq311m5">
                C&apos;est un système pédagogique professionnel complet : tu entres en cours totalement préparé, confiant et prêt
                à enseigner une leçon dont tes élèves vont vraiment apprendre.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}